import { render } from "./MySuggestionsLink.vue?vue&type=template&id=7281119f"
import script from "./MySuggestionsLink.vue?vue&type=script&lang=js"
export * from "./MySuggestionsLink.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/projectes/suggestions/suggeriments-upcommons/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__